export default "__VITE_ASSET__BAwPwGJ5__"